import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import AddQuestion from "./pages/AddQuestion";

import "bootstrap/dist/css/bootstrap.min.css";

import QuestionDetailPage from "./components/QuestionDetailPage";
import ViewQuestion from "./components/ViewQuestion";
import EditQuestion from "./components/EditQuestion";

import QuestionBankAll from "./pages/QuestionBank";
import AddquestionBank from "./pages/AddquestionBank";
import QuestionBankDetails from "./pages/QuestionBankDetails";

function App() {

  const [isLoggedIn, setIsLoggedIn] = useState(
    !!localStorage.getItem("adminToken")
  );

  return (
    <Router>
      <Routes>

        {/* PUBLIC */}
        <Route
          path="/"
          element={
            isLoggedIn ? (
              <Navigate to="/dashboard" />
            ) : (
              <Login setIsLoggedIn={setIsLoggedIn} />
            )
          }
        />

        {/* PROTECTED */}
        <Route
          path="/dashboard/*"
          element={
            isLoggedIn ? (
              <Dashboard setIsLoggedIn={setIsLoggedIn} />
            ) : (
              <Navigate to="/" />
            )
          }
        >
          <Route index element={<div>Select a menu item</div>} />

          <Route path="add-question-bank" element={<AddquestionBank />} />

          <Route path="question-bank" element={<QuestionBankAll />} />

          <Route path="question-bank/view/:id" element={<ViewQuestion />} />

          <Route path="question-bank/edit/:id" element={<EditQuestion />} />

          <Route path="question-detail/:id" element={<QuestionDetailPage />} />

          <Route
            path="question-bank/bank/:id"
            element={<QuestionBankDetails />}
          />

          <Route path="add-question" element={<AddQuestion />} />
        </Route>

        {/* FALLBACK */}
        <Route
          path="*"
          element={
            <Navigate
              to={isLoggedIn ? "/dashboard" : "/"}
            />
          }
        />

      </Routes>
    </Router>
  );
}

export default App;